import React from 'react';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import useProtectedByAuth from '@giro-pdv/hooks/useProtectedByAuth.hook';
import useFetchHook from '@giro-pdv/hooks/useFetch.hook';
import useAuth from '@giro/shared-hooks/useAuth.hook';
import getApiClientsService from '@giro/shared-services/pdv/getApiClients.service';
import clients from '@giro-pdv/modules/pdv/store/clients';

import AppLayout from '@giro-pdv/layouts/App.layout';

import ROUTES from '@giro-pdv/constants/routes.constant';

import TerminalsScreen from './screens/Terminals.screen';
import { hasGtappAccess } from './terminals.types';

const TerminalsModule = () => {
  useProtectedByAuth();
  const { signedIn } = useAuth();
  const dispatch = useDispatch();
  // Fetch the entitlement on direct navigation/reload, without mounting the PDV
  // module (which also initializes the pinpad and payment session).
  const clientFetch = useFetchHook(getApiClientsService, {
    requestOnMount: signedIn,
  });

  React.useEffect(() => {
    if (clientFetch.data) {
      dispatch(clients.action.fetchSuccess(clientFetch.data));
    }
  }, [clientFetch.data, dispatch]);

  if (!signedIn) return null;

  if (clientFetch.error) {
    return (
      <AppLayout>
        <Alert severity="error">
          Não foi possível verificar o acesso aos terminais.
          <Button onClick={() => clientFetch.handleFetch()}>
            Tentar novamente
          </Button>
        </Alert>
      </AppLayout>
    );
  }

  if (!clientFetch.isSuccess) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress aria-label="Verificando acesso aos terminais" />
      </Box>
    );
  }

  if (!hasGtappAccess(clientFetch.data)) {
    return <Redirect to={ROUTES.PDV.ROOT} />;
  }

  return (
    <AppLayout>
      <Switch>
        <Route exact path={ROUTES.TERMINALS.ROOT} component={TerminalsScreen} />

        <Redirect to={ROUTES.TERMINALS.ROOT} />
      </Switch>
    </AppLayout>
  );
};

export default TerminalsModule;
